import { render, staticRenderFns } from "./create-edit-client-admin-modal.vue?vue&type=template&id=3aad8d2c"
import script from "./create-edit-client-admin-modal.vue?vue&type=script&lang=js"
export * from "./create-edit-client-admin-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports